import {Component, ElementRef, Input, OnDestroy,OnInit, ViewChild} from '@angular/core';
import {UntypedFormGroup} from "@angular/forms";
import {ActivatedRoute} from "@angular/router";
import { RadioState } from "@vg-constellation/angular-17/radio";
import {Subject, takeUntil} from "rxjs";
import { FundFamilyDetails  } from 'src/app/models/fund-details.model';
import { AdobeLaunchService } from 'src/app/services/adobe-launch.service';
import { FiltersService } from 'src/app/services/filtersService.service';

import { DataFilters } from "../../../models/DataFilters.model";
import { FILTER_MAP, PRODUCT_TYPE } from "../../../models/filter-details.model";
import { FundDetailService } from "../../../services/fund-detail.service";
import { FundDetailsService } from "../../../services/fund-details.service";
import { LoadingService } from "../../../services/loading.service";
import { ListPageComponent } from '../../list-page/list-page.component';


const NON_VANGUARD_MUTUAL_FUNDS = 'non-vanguard-mutual-funds';

@Component({
  selector: 'product-type-filter',
  templateUrl: './productTypeFilter.component.html',
  styleUrls: ['./productTypeFilter.component.scss'],
})
export class ProductTypeFilterComponent implements OnInit, OnDestroy {
  @ViewChild('fundFamilySelect') fundFamilySelect: ElementRef<HTMLElement>;
  @Input() showFilters: boolean;
  @Input() initialPageLoad: boolean;
  @Input() accountingTypeOptions: any;
  @Input() numAppliedFilters = 0

  public activeFilters: DataFilters;
  public fundFamilySelection: string;
  public fundFamilyDetails: FundFamilyDetails[];
  public inputId: any;
  public fundFamilyName: string;
  public hasLoadFunds: boolean;
  public hasNTFFunds: boolean;
  public totalNumberOfFunds: number;
  public inputLabel: any;
  public isMutualFundsSelected: boolean;
  public value: string
  public radioGroupState:RadioState
  public checkedSelection: any

  // eslint-disable-next-line max-params
  constructor(
    public filtersService: FiltersService,
    private readonly listPageComponent: ListPageComponent,
    public adobeLaunchService: AdobeLaunchService,
    private readonly fundDetailService: FundDetailService,
    private readonly loadingService: LoadingService,
    private readonly fund: FundDetailsService,
    private route: ActivatedRoute
  ) {}

  public readonly filterMap = FILTER_MAP;
  public readonly productTypeFilters: string[] = PRODUCT_TYPE;
  public productTypeGroup: UntypedFormGroup
  private destroy$ = new Subject<void>();

  ngOnInit() {
    this.productTypeGroup = this.filtersService.activeFilters.productType;
    this.isMutualFundsSelected = this.productTypeGroup.value['mutual-funds'] && !this.productTypeGroup.value['etfs'];

    // Check the route and set the checkbox state accordingly
    this.route.url.subscribe(url => {
      const routePath = url[0]?.path;
      if (routePath === 'mutual-funds') {
        this.productTypeGroup.patchValue({ 'mutual-funds': true, 'etfs': false }, { emitEvent: false });
        this.isMutualFundsSelected = true;
      } else if (routePath === 'etfs') {
        this.productTypeGroup.patchValue({ 'mutual-funds': false, 'etfs': true }, { emitEvent: false });
        this.isMutualFundsSelected = false;
      }
      else if (routePath === 'non-vanguard-mutual-funds') {
        this.productTypeGroup.patchValue({ 'mutual-funds': true, 'etfs': false }, { emitEvent: false });
        this.isMutualFundsSelected = true;
      }
    });

    // Subscribe to value changes
    this.productTypeGroup.valueChanges.subscribe(value => {
      this.checkboxStateChange(value);
    });

    // Fetch fund family details
    this.fundDetailService.getfundFamily()
      .pipe(takeUntil(this.destroy$))
      .subscribe((response) => {
        this.fund.updateFundFamilyDetails(response);
        this.fundFamilyDetails = response.fundFamily.filter(item => item.fundFamilyName !== "Vanguard");
      });
    this.fundFamilyNameForSubfilter();
  }

  ngOnDestroy() {
    this.destroy$.next();
  }

  fundFamilyNameForSubfilter() {
    // Purpose of this method is to change subfilter's Fund Family name dynamically and on page refresh
    this.fundDetailService.getfundFamily()
      .pipe()
      // eslint-disable-next-line max-statements, complexity
      .subscribe((response) => {
        this.fundFamilyDetails = response.fundFamily;
        const fundFamilyNames = this.fundFamilyDetails

        if(this.filtersService.activeFilters.discoverBy === 'non-vanguard-mutual-funds') {
          this.inputId = this.filtersService.FundFamilyId
          for (let i = 0; i < fundFamilyNames.length; i++) {
            if(Number(this.inputId) === fundFamilyNames[i].fundFamilyId) {
            // Compare Selected fund family Id with the Id in the query param
              this.fundFamilyName = this.fundFamilyDetails[i].fundFamilyName
              this.hasLoadFunds = this.fundFamilyDetails[i].hasLoadFunds
              this.hasNTFFunds = this.fundFamilyDetails[i].hasNTFFunds
              this.inputId = this.fundFamilyDetails[i].fundFamilyId
              this.totalNumberOfFunds = this.fundFamilyDetails[i].totalNumberOfFunds
              this.fundFamilySelection = this.fundFamilyName + (this.hasLoadFunds ? ' [Load]' : '') + (this.hasNTFFunds ? ' [NTF]' : '')
              this.listPageComponent.NVGnumTotalResults = response.fundFamily[i].totalNumberOfFunds
              break;
            }
          }
        }
        else {
          this.fundFamilySelection = 'Vanguard';
          this.inputId = 'vanguard'
        }
      });
    if(this.filtersService.FundFamilyId){
      this.fundDetailService.getfundFamilyDetail(this.filtersService.FundFamilyId).subscribe((response) => {
        this.fund.updateFundFamilyDetails(response)
      })
    }
    this.inputLabel = this.fundFamilySelection
  }

  // eslint-disable-next-line complexity
  checkboxStateChange(value) {
    this.showFilters = false;
    this.isMutualFundsSelected = value['mutual-funds'] && !value['etfs'];

    switch (true) {
      case value['mutual-funds'] && value['etfs']:
        this.filtersService.activeFilters.discoverBy = 'all';
        break;
      case value['mutual-funds']:
        this.filtersService.activeFilters.discoverBy = 'mutual-funds';
        break;
      case value['etfs']:
        this.filtersService.activeFilters.discoverBy = 'etfs';
        break;
      default:
        this.filtersService.activeFilters.discoverBy = 'all';
    }
    this.triggerAdobeLaunchCTA(this.filtersService.activeFilters.discoverBy);


    if (value['mutual-funds']) {
      this.fundFamilySelection = 'Vanguard';
    }

    this.listPageComponent.filteredCount();
    this.listPageComponent.productTypeTotalResults();
    this.filtersService.applyFilters();

    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    setTimeout(() => this.showFilters = true, 50);
    this.initialPageLoad = false;
  }

  getRadioButton(event: any): void {
    if (event.inputId) {
      this.inputId = event.inputId
      this.inputLabel = event.inputLabel;
    }
    else{
      this.checkedSelection = this.inputId
      this.inputId = event.radioGroupState.inputId
      this.inputLabel = event.radioGroupState.inputLabel
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  applyButton(event:any){
    if (this.inputId !== 'vanguard') {
      this.filtersService.activeFilters.discoverBy = 'non-vanguard-mutual-funds'
      event = this.inputLabel
      this.fundFamilySelection = event

      this.fundDetailService.getfundFamilyDetail(this.inputId).subscribe((response) => {
        this.fund.updateFundFamilyDetails(response)
        this.adobeLaunchService.subPageTabEvent(`non-vanguard-mutual-fund:radio ${this.fundFamilySelection}`)
        this.listPageComponent.NVGnumTotalResults = response?.fund?.entity?.length
        // filtersService Fetches the Id from the API
        this.filtersService.FundFamilyId = this.inputId
        this.listPageComponent.fetchFundFamilyNameForHeader()
        this.filtersService.applyFilters()
      })
      this.listPageComponent.isOnLoad = false
    }
    else {
      this.filtersService.activeFilters.discoverBy = 'mutual-funds'
      this.triggerAdobeLaunchCTA('mutual-funds');
      this.fundFamilySelection = this.inputLabel;
      this.filtersService.applyFilters()
    }
  }

  triggerAdobeLaunchCTA(option: string){
    let optionLabel = this.accountingTypeOptions[option]
    if(option=== "mutual-funds"){
      optionLabel="Vanguard Mutual Funds"
    } else if(option=== NON_VANGUARD_MUTUAL_FUNDS){
      optionLabel="Non-Vanguard Mutual Funds"
    }
    this.adobeLaunchService.callToAction(
      optionLabel,
      'Dynamic Funds List Page - Discover Vanguard Section',
      'Link',
    )
  }
}
